import React from 'react';

export const LocaleContext = React.createContext({});
LocaleContext.displayName = 'LocaleContext';
